import {Localize} from "@dp-instant/i18n";
import {visibilityEffect} from "@dp-instant/ui";
import {UIConstants} from "@game/ui/constants";
import {apiClient} from "@game/api/ApiClient";
import {playUIClickSound} from "@game/helpers";
import {SVG} from "@game/ui/images";
import cn from "classnames";
import {useState} from "preact/hooks";
import "./InsufficientCoinsPopup.less";

type InsufficientCoinsPopupProps = {
    deficit: number;
    packCoins: number;
    packPrice: number;
    packSlug: string;
    onClose: () => void;
    onPurchased: (coins: number) => void;
};

export const InsufficientCoinsPopup = ({deficit, packCoins, packPrice, packSlug, onClose, onPurchased}: InsufficientCoinsPopupProps) => {
    const [invisible] = visibilityEffect(UIConstants.popup.startDelay);
    const [busy, setBusy] = useState(false);

    const handleBuy = async () => {
        if (busy) return;
        playUIClickSound();
        setBusy(true);
        try {
            const {paid} = await apiClient.purchaseFlow(packSlug);
            if (paid) {
                onPurchased(packCoins);
            } else {
                setBusy(false);
            }
        } catch {
            setBusy(false);
            const tg = (window as any).Telegram?.WebApp;
            tg?.showAlert?.(Localize.get("ui-payment-error", "Payment error. Please try again."));
        }
    };

    return (
        <div className="popups">
            <div className={cn("popup-insufficient", {invisible})}>
                <div className="popup-insufficient__icon"><SVG.COINS /></div>
                <div className="popup-insufficient__title">
                    {Localize.get("ui-insufficient-title", "Not enough coins")}
                </div>
                <div className="popup-insufficient__deficit">
                    {Localize.get("ui-insufficient-need", "Need")}: {deficit}
                </div>
                <div className="popup-insufficient__offer">
                    {packCoins} <SVG.COINS /> → {packPrice} ⭐
                </div>
                <button
                    className={cn("btn-green", "popup-insufficient__buy-btn")}
                    disabled={busy}
                    onClick={handleBuy}
                >
                    {busy ? "..." : `${Localize.get("ui-insufficient-buy", "Buy")} ${packPrice} ⭐`}
                </button>
                <button
                    className="popup-insufficient__cancel"
                    onClick={() => { playUIClickSound(); onClose(); }}
                >
                    {Localize.get("ui-common-cancel", "CANCEL")}
                </button>
            </div>
        </div>
    );
};
